import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-line bg-white px-4 py-12" data-id="element-160" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto max-w-4xl text-center" data-id="element-161" data-mp="32nulgo2wc31d">
        <p className="text-lg font-black uppercase tracking-tight text-primary" data-id="element-162" data-mp="32p5qer82vgu2">
          🏃 Combo Completo Running 2026
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-163" data-mp="36n3bpiyq9is6">
          El sistema de running, especialización y adaptaciones para corredores de todos los niveles
          en Argentina.
        </p>
        <p className="mt-2 text-sm font-semibold text-slate-500" data-id="element-164" data-mp="36ms6hozeurf">
          Porque correr no debería ser un misterio. Debería ser un SISTEMA.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-slate-600 sm:flex-row sm:gap-6" data-id="element-165" data-mp="3qcds6z6as7rc">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-accent" href="mailto:compradigitalyaa@gmail.com" data-id="element-166" data-mp="2a19tpmiidoxa">
            <MailIcon className="h-4 w-4" data-id="element-167" data-mp="3l9shv2i5sonf" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-accent" href="https://www.compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-168" data-mp="3gc0ftfnsvm5i">
            <GlobeIcon className="h-4 w-4" data-id="element-169" data-mp="82qplkz0zfq1" /> www.compradigitalya.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-accent" href="https://instagram.com/compradigitalya" target="_blank" rel="noopener noreferrer" data-id="element-170" data-mp="33xe1y3atysi">
            <InstagramIcon className="h-4 w-4" data-id="element-171" data-mp="cu8tagsfnuep" /> @compradigitalya
          </a>
        </div>
        <div className="mt-7 border-t border-line pt-6" data-id="element-172" data-mp="qu1gi24r3shx">
          <p className="text-base font-black text-ink" data-id="element-173" data-mp="ms6d8s39f51i">
            🏃 “El próximo ciclo puede ser diferente.”
          </p>
          <p className="mt-1 text-sm font-semibold italic text-accent-dark" data-id="element-174" data-mp="tw5wk16p5gk3">
            “Finalmente un entrenamiento que FUNCIONA.”
          </p>
          <p className="mt-5 text-xs font-semibold text-slate-400" data-id="element-175" data-mp="yrv0egpr1jm7">
            © CompraDigitalYa™ 2026 — Todos los derechos reservados.
            <br data-id="element-176" data-mp="18k943f0e10b0" />
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}